<template>
  <!-- begin navbar-collapse -->
  <div
    class="collapse navbar-collapse pull-left"
    id="top-navbar"
    v-bind:class="{ 'd-block': pageOptions.pageMobileMegaMenu }"
  >
    <ul class="nav navbar-nav">
      <li>
        <a href="javascript:;">
          <i class="fa fa-gem fa-fw"></i> Client
        </a>
      </li>
      <li class="dropdown">
        <b-dropdown variant="link">
          <template slot="button-content">
            <i class="fa fa-database fa-fw"></i> New
            <b class="caret"></b>
          </template>
          <b-dropdown-item href="#">Action</b-dropdown-item>
          <b-dropdown-item href="#">Another action</b-dropdown-item>
          <b-dropdown-item href="#">Something else here...</b-dropdown-item>
          <b-dropdown-divider></b-dropdown-divider>
          <b-dropdown-item href="#">Separated link</b-dropdown-item>
          <b-dropdown-divider></b-dropdown-divider>
          <b-dropdown-item href="#">One more separated link</b-dropdown-item>
        </b-dropdown>
      </li>
    </ul>
  </div>
  <!-- end navbar-collapse -->
</template>

<script>
import PageOptions from "../../config/PageOptions.vue";

export default {
  name: "HeaderMegaMenu",
  data() {
    return {
      pageOptions: PageOptions
    };
  }
};
</script>
